/**
 * The single AudioContext for the app.
 *
 * Browsers start it suspended until a user gesture, so `unlockAudio` is wired to
 * the first pointer/key event and every later call is a no-op.
 */
export const audioContext = new AudioContext({ latencyHint: 'interactive' });

let unlocking: Promise<void> | null = null;

export function unlockAudio(): Promise<void> {
  if (audioContext.state === 'running') return Promise.resolve();
  unlocking ??= audioContext.resume().finally(() => {
    unlocking = null;
  });
  return unlocking;
}

export function installAudioUnlock(): () => void {
  const events = ['pointerdown', 'keydown', 'touchstart'] as const;
  const handler = () => void unlockAudio();
  for (const event of events) window.addEventListener(event, handler, { passive: true });
  return () => {
    for (const event of events) window.removeEventListener(event, handler);
  };
}
